var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { ColumnBaseSelectComponent } from '../base/columnbase-select.component';
import { ColumnService } from '../column/column.service';
import { ColumnBaseService } from '../base/columnbase.service';
import { ConfigService } from '../../../service/config.service';
var RadioComponent = /** @class */ (function (_super) {
    __extends(RadioComponent, _super);
    function RadioComponent(service, baseService, cdRef, config) {
        var _this = _super.call(this, service, baseService, cdRef) || this;
        _this.service = service;
        _this.baseService = baseService;
        _this.cdRef = cdRef;
        _this.config = config;
        _this.noInitSelect = false;
        _this.unselectedOption = new UnselectedOption();
        return _this;
    }
    RadioComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setValue();
    };
    RadioComponent.prototype.ngOnChanges = function (changes) {
        if ((changes.col || changes.msg) && this.col && this.msg) {
            this.setNoInitSelect();
            this.setUnselectedOption();
        }
        if (!this.changeValFlg) {
            this.setValue();
        }
        _super.prototype.ngOnChanges.call(this, changes);
    };
    RadioComponent.prototype.setNoInitSelect = function () {
        var noInitSelect = false;
        var key = (this.col.required ? 'required_no_init_select' : 'not_required_no_init_select');
        if (this.config.config[key]) {
            noInitSelect = (this.config.config[key] === 'true' ? true : false);
        }
        if (this.col.params && typeof this.col.params.noInitSelect !== 'undefined') {
            noInitSelect = this.col.params.noInitSelect;
        }
        this.noInitSelect = noInitSelect;
    };
    RadioComponent.prototype.setUnselectedOption = function () {
        var option = new UnselectedOption();
        var hiddenKey = (this.col.required === true ? 'required_unselected_option_hidden' : 'not_required_unselected_option_hidden');
        var displayKey = this.config.config['radio_unselected_option_display'] || '';
        option.hidden = (this.col.required === true ? true : false);
        option.display = this.msg['RadioComponent.label.notSet'];
        if (this.config.config[hiddenKey]) {
            option.hidden = (this.config.config[hiddenKey] === 'true' ? true : false);
        }
        if (displayKey && this.msg[displayKey]) {
            option.display = this.msg[displayKey];
        }
        if (this.col.params && this.col.params.unselectedOption) {
            option = Object.assign(option, this.col.params.unselectedOption);
        }
        this.unselectedOption = option;
    };
    RadioComponent.prototype.setValue = function () {
        if (typeof this.val === 'undefined' || this.val === null || this.val === '') {
            var options = (this.col.params && this.col.params.options ? this.col.params.options : []);
            if (options.length > 0 && this.unselectedOption.hidden) {
                this.val = options[0].code;
            }
            else {
                this.val = '';
            }
            if (this.noInitSelect === true) {
                this.val = null;
            }
            _super.prototype.onChange.call(this, this.val, false);
        }
        if (this.val !== null) {
            this.val = this.val.toString();
        }
    };
    RadioComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'column-radio',
                    template: "<ng-template [ngIf]=\"!unselectedOption.hidden\">\n  <input type=\"radio\" id=\"{{ colKey }}-\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" value=\"\" [(ngModel)]=\"val\" (change)=\"onChange(val)\" [key]=\"key\" [col]=\"col\" columnDir>\n  <label for=\"{{ colKey }}-\" [key]=\"key\" [col]=\"col\" columnDir>{{ unselectedOption.display }}</label>\n  <br *ngIf=\"col.params?.vertical === true && col.params?.options?.length > 0\">\n</ng-template>\n<ng-template ngFor let-option [ngForOf]=\"col.params.options\" let-index=\"index\" [ngForTrackBy]=\"trackByOption\">\n  <input type=\"radio\" id=\"{{ colKey }}-{{ option.code }}\" name=\"{{ colKey }}\" attr.name=\"{{ colKey }}\" [value]=\"option.code.toString()\" [(ngModel)]=\"val\" (change)=\"onChange(val)\" [key]=\"key\" [col]=\"col\" columnDir>\n  <label for=\"{{ colKey }}-{{ option.code }}\" [key]=\"key\" [col]=\"col\" columnDir>{{ option.display }}</label>\n  <br *ngIf=\"col.params?.vertical === true && index < col.params.options.length - 1\">\n</ng-template>\n",
                    changeDetection: ChangeDetectionStrategy.OnPush
                }] }
    ];
    /** @nocollapse */
    RadioComponent.ctorParameters = function () { return [
        { type: ColumnService },
        { type: ColumnBaseService },
        { type: ChangeDetectorRef },
        { type: ConfigService }
    ]; };
    return RadioComponent;
}(ColumnBaseSelectComponent));
export { RadioComponent };
var UnselectedOption = /** @class */ (function () {
    function UnselectedOption() {
    }
    return UnselectedOption;
}());
//# sourceMappingURL=radio.component.js.map